import React from "react";
import { connect } from "react-redux";
import UserAvatar from "../../../assets/images/Rome.png";
import TradeAlertsAndSignals from "../TradeAlertsAndSignals";
import LivestreamPage from "../../common/LivestreamPage";

const EmeraldCommonPage = ({
  title,
  subTitle,
  description,
  eventID,
  from,
  themeMode,
}) => {
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  const schedules = days.map((day) => ({
    day,
    time: from === "livestream" ? "3:00pm EST" : "4:00pm EST",
  }));

  return (
    <LivestreamPage
      eventID={eventID}
      videoKey={title === "Livestream" ? "emerald-income" : "emerald-income-qa"}
      titleFilter={
        title === "Livestream" ? "Trade Algo Emerald Income Alerts" : null
      }
      pageTitle={true}
      liveTitle={title}
      pastStreamTitle="Past Stream"
      authorName="Roman Radenski"
      authorTitle="TradeAlgo Professional Analyst"
      authorAvatar={UserAvatar}
      contentTitle={subTitle}
      contentDescription={description}
      showSchedule={true}
      schedules={schedules}
      scheduleTitle="Live Schedule"
      sidebarComponent={
        <TradeAlertsAndSignals
          themeMode={themeMode}
          url="https://t.me/+WKhGeIKkzPE5YTZh"
        />
      }
      customPageSize={title === "Livestream" ? 19 : 9}
      className="emerald-common-page"
    />
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

export default connect(stateToProps, null)(EmeraldCommonPage);
